import React from "react";
import { useRoutes } from "react-router-dom";
import Login from "./screens/Login";
import DashboardLayout from "./screens/DashboardLayout";
import Unauthorized from "./screens/Unauthorized";

export const AppRouter = () => {
    const elements = useRoutes([
        { path: "/", element: <Login /> },
        { path: "/unauthorized", element: <Unauthorized /> },
        { path: "/home/*", element: <DashboardLayout /> },
    ]);
    return elements;
};